import React, { useState, useEffect } from 'react';
import Portal from '../common/Portal';

const UpdateLivestockStatusModal = ({ isOpen, onClose, onSubmit, isLoading, animal }) => {
    const [newStatus, setNewStatus] = useState('');

    useEffect(() => {
        if (animal) {
            setNewStatus(animal.status || 'Milking'); // Default to 'Milking' if no status is set
        }
    }, [animal]);

    if (!isOpen) return null;

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(animal.id, newStatus);
    };

    const statusOptions = ["Milking", "Dry (Not Milking)", "Pregnant", "Feeding", "Sold", "Dead"];

    return (
        <Portal>
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-md m-4">
                    <h2 className="text-2xl font-bold mb-2 text-gray-800">Update Status</h2>
                    <p className="text-sm text-gray-600 mb-6">For: {animal.name} ({animal.tagNumber})</p>
                    <form onSubmit={handleSubmit}>
                        <div className="space-y-4">
                            <div>
                                <label htmlFor="status" className="block text-sm font-medium text-gray-700">New Status</label>
                                <select 
                                    name="status" 
                                    id="status" 
                                    value={newStatus} 
                                    onChange={(e) => setNewStatus(e.target.value)} 
                                    className="mt-1 block w-full form-select rounded-md shadow-sm"
                                >
                                    {statusOptions.map(status => (
                                        <option key={status} value={status}>{status}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="mt-8 flex justify-end space-x-3">
                            <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300">Cancel</button>
                            <button type="submit" disabled={isLoading} className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:bg-indigo-300 flex items-center">
                                {isLoading ? 'Updating...' : 'Update Status'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Portal>
    );
};

export default UpdateLivestockStatusModal;